import script from "./OptimisationScoreBars.vue?vue&type=script&setup=true&lang=js"
export * from "./OptimisationScoreBars.vue?vue&type=script&setup=true&lang=js"

import "./OptimisationScoreBars.vue?vue&type=style&index=0&id=6c7d9230&lang=css"

const __exports__ = script;

export default __exports__